document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.classList.add("with-js")
})
